import StructLoader from "@/components/StructLoader/StructLoader";
import BFMessage from "@/modules/abstract-ui/general/Message/BFMessage";
import classNames from "classnames";
import i18n from "../../../../i18n";
import RAInvoiceProcessHistory from "./InvoiceProcessHistory/RAInvoiceProcessHistory";
import "./RAInvoiceEntryView.scss";
import RAInvoiceEntryViewFields, {
  RAInvoiceEntryViewFieldProps,
} from "./RAInvoiceEntryViewFields";

type Props = RAInvoiceEntryViewFieldProps & {
  ignoreHistory?: boolean;
};
const RAInvoiceEntryView = (props: Props) => {
  if (!props.invoice) {
    return (
      <div>
        <BFMessage
          type="warning"
          text={i18n.t(
            "ra:ApproveList.Entry.noPermissionToViewInvoice",
            "Sie haben keine Berechtigung diese Rechnung zu sehen."
          )}
        />
      </div>
    );
  }
  // return (
  //   <div>
  //     <div>TODO_INVOICE</div>
  //     <div>RAInvoiceEntryView</div>
  //   </div>
  // );
  return (
    <StructLoader
      structTypes={["orga", "invoice"]}
      unitType={props.invoice.data.type}
      render={() => (
        <div
          className={classNames("ra-invoice-entry-view", {
            "display-beneath": props.displayBeneath,
            dense: props.dense,
          })}
        >
          {props.ignoreHistory !== true && (
            <div className="left">
              <RAInvoiceProcessHistory
                maxHistoryHeight={props.maxHistoryHeight}
                invoice={props.invoice}
              />
            </div>
          )}
          <div className="right">
            <RAInvoiceEntryViewFields {...props} />
          </div>
        </div>
      )}
    />
  );
};
export default RAInvoiceEntryView;
